export const EVENT_BET_CHANGED = 'betChanged'
export const EVENT_REQUEST_BET_VALUE = 'requestBet'
export const EVENT_BET_VALUE = 'betValue'
export const EVENT_CLOSE_GAME = 'closeGame'
export const EVENT_CREDITS_CHANGED = 'creditsChanged'
export const EVENT_FOCUS_IN = 'focusIn'
export const EVENT_FOCUS_OUT = 'focusOut'
export const EVENT_GAME_CLOSED = 'gameClosed'
export const EVENT_GAME_LOADING = 'gameLoading'
export const EVENT_GAME_LOADED = 'gameLoaded'
export const EVENT_GAME_OUTCOME = 'gameOutcome'
export const EVENT_GAME_READY = 'gameReady'
export const EVENT_GAME_ERROR = 'error'
export const EVENT_GAME_MESSAGE = 'message'
export const EVENT_GAME_STATE_CHANGED = 'gameStateChanged'
export const EVENT_GAME_TRACK_EVENT = 'gameTrackEvent'
export const EVENT_MEASUREMENT = 'measurement'
export const EVENT_NO_MORE_ROUNDS = 'noMoreRounds'
export const EVENT_NOTIFICATION = 'notification'
export const EVENT_OUT_OF_CREDITS = 'outOfCredits'
export const EVENT_RELOAD_GAME = 'reloadGame'
export const EVENT_REQUEST_RESTART = 'requestRestart'
export const EVENT_SHOW_DIALOG = 'showDialog'
export const EVENT_SOUND_TOGGLED = 'soundToggled'
export const EVENT_TOGGLE_AUTO_SPIN = 'toggleAutoSpin'
export const EVENT_TOGGLE_DRAW = 'toggleDraw'
export const EVENT_TOGGLE_FULLSCREEN = 'toggleFullscreen'
export const EVENT_TOGGLE_GAME_PAYMENT = 'toggleGamePayment'
export const EVENT_TOGGLE_SOUND = 'toggleSound'
export const EVENT_TOGGLE_MENU = 'showMenu'
export const EVENT_OPEN_GAME_MANUAL = 'openGameManual'
export const EVENT_GAME_EFFECT = 'effect'
export const EVENT_GAME_CLOSE_FAILED = 'game_close_failed'
export const EVENT_TIME_CONTROL = 'timeControl'
export const EVENT_ENABLE_AUTO_PLAY = 'enableAutoPlay'

// EVENT NOTIFICATION TYPES
export const EVENT_NOTIFICATION_TYPE_NOTICE = 'notice'
export const EVENT_NOTIFICATION_TYPE_ATTENTION = 'requireAttention'

// GAME EVENTS
export const GAME_EVENT_GAME_CLOSED_DUE_TO_INACTIVITY = 201
export const GAME_EVENT_RESOURCE_LOAD_FAILED = 718
export const GAME_EVENT_BINGO_ROOM_FULL = 800
export const GAME_EVENT_INITIALIZATION_ERROR = 1100

export const GAME_EVENT_CODES = [
    GAME_EVENT_GAME_CLOSED_DUE_TO_INACTIVITY,
    GAME_EVENT_INITIALIZATION_ERROR,
    GAME_EVENT_BINGO_ROOM_FULL,
    GAME_EVENT_RESOURCE_LOAD_FAILED
]

export const SESSION_LOAD_FAILED = 'sessionLoadFailed'
